import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SplitButtonModule as PrimeNgSplitButton } from '@openng/optimus-ui/splitbutton';

import { SplitbuttonComponent } from './splitbutton.component';

@NgModule({
  imports: [CommonModule, PrimeNgSplitButton],
  declarations: [SplitbuttonComponent],
  exports: [SplitbuttonComponent],
})
export class SplitButtonModule {}
